import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">About</span>
                    <h2 className="colorlib-heading">Artist Statement</h2>
                    <p>While my early background was absorbed in visual arts, since architecture school I have mostly focused on work as an architect rather than painting.  However, during the Covid pandemic years, I returned to art in the absence of socialization as an outlet for expression.  To counter the sad news and isolation of the pandemic, I became introspective and saw vivid colorful spaces alongside my turmoil of emotions, health and sickness during this time of quarantine.  My paintings could be expressions of geometric symbolic places as an escape to an imagined world even if no one else could be around me.  Painting was something I returned to during the pandemic that brought me joy, and became a necessity of life in this dystopian altered world.</p>
                    <p>Technically speaking, these geometric abstract paintings are inspired by the color field movement, cubism and optical art. I designed the images to have a sense of three dimensionality, giving a disoriented view of an enclosed space or abstracted room.  These are my visions of imaginary architectural spaces charged with deeply contrasting emotional colors. The colors have symbolic meanings such as sadness, fear, and hope. I seek to strike a balance that resolves emotional conflict with visual harmony. Mostly I define the spaces with hard edge geometries but within these bounds of quarantine painterly textures emerge. Solids and voids build up and carve away spaces inside the canvas.  Like the sense of introspection that motivated me to paint this series, there is a longing to connect with a future viewer in the space that never seems to end.</p>

                    Charlotte Townes
                    <br/>
                    AIA, NCARB
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
      </div>
    )
  }
}
